module.exports = {
      id: "filter-icon-usage",
      viewBox: "0 0 13 14",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#filter-icon",
      toString: function () {
        return this.url;
      }
    }